import { memo } from 'react'
import { shallowEqual } from 'react-redux'

import { BaseNumberInput } from './components/baseNumberInput/BaseNumberInput'
import { ValidateNumberInput } from './components/validateNumberInput/ValidateNumberInput'
import { INumberInputProps } from './models'

export const NumberInput = memo<INumberInputProps>((props) => {
  if (props.checkFn) {
    return <ValidateNumberInput checkFn={props.checkFn} {...props} classes={props.classes} />
  }
  return <BaseNumberInput {...props} classes={props.classes?.inputClasses} />
}, shallowEqual)
